var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4431",
    "data-name": "Group 4431",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.838,
    height: 27.838,
    viewBox: "0 0 27.838 27.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 13.919,
    cy: 13.919,
    r: 13.919,
    transform: "translate(0 0)",
    fill: "#0a64f9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M825.989,185.276a5.567,5.567,0,0,0-5.567,5.567c0,3.977,5.567,9.148,5.567,9.148s5.568-4.971,5.568-9.148A5.567,5.567,0,0,0,825.989,185.276Zm0,8.153a2.585,2.585,0,1,1,2.585-2.585A2.585,2.585,0,0,1,825.989,193.429Z",
    transform: "translate(-812.071 -178.714)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.5bc1834748fc409e6428bc99e18cebe1.svg";
export { ForwardRef as ReactComponent };